/** Parse a single SSE frame into a typed event.
 *  Returns null for keep-alives (no data: lines) or frames with malformed JSON. */
export function parseSseFrame<TEvent>(frame: string): TEvent | null {
  const dataLines = frame
    .split(/\r?\n/)
    .filter((line) => line.startsWith('data:'))
    .map((line) => line.slice(5).replace(/^ /, ''));
  if (dataLines.length === 0) return null;
  try {
    return JSON.parse(dataLines.join('\n')) as TEvent;
  } catch {
    return null;
  }
}
